import React from 'react'

import { useSiteFeatures } from '@hooks/siteFeatures'

import { DownstreamTaskList } from './Lists/DownstreamList'
import { MidstreamTaskList } from './Lists/MidstreamList'

export function TaskList() {
  const { isMidstreamProcess } = useSiteFeatures()

  return (
    <>{isMidstreamProcess ? <MidstreamTaskList /> : <DownstreamTaskList />}</>
  )
}
